// src/admin/components/AdminGuard.jsx
import React, {useContext} from "react";
import { UserContext } from "../../UserContext"

const AdminGuard = ({ children }) => {
   const { user } = useContext(UserContext);

  if (!user) return null;

  const allowedRoles = ["Admin", "Super Admin"]; // match your role strings

  if (!allowedRoles.includes(user?.role_name)) {
    return <div className="p-6 text-red-600">Access denied.</div>;
  }

  return children;
};

export default AdminGuard;
